import React, { useState } from 'react';
import { FaCalendarMinus } from 'react-icons/fa';
import { FaUserEdit } from 'react-icons/fa';
import './add-absent.css';
import { Row, Form, Col, Button } from 'react-bootstrap';
import { IoMdAdd } from "react-icons/io";

// Dummy CustomSelect component (replace with your actual implementation)
const CustomSelect = ({ options, value, onChange, placeholder }) => (
  <Form.Control
    as="select"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
  >
    <option value="">{placeholder}</option>
    {options.map((option, index) => (
      <option key={index} value={option.value}>
        {option.label}
      </option>
    ))}
  </Form.Control>
);

export default function AddAbsent() {
  const [username, setUsername] = useState('');
  const [date, setDate] = useState('');

  // Dummy username options (replace with your actual data)
  const usernameOptions = [
    { value: 'user1', label: 'User 1' },
    { value: 'user2', label: 'User 2' },
    { value: 'user3', label: 'User 3' }
  ];

  return (
    <>
      <div>
        <h1 className="add-absent-title">
          <FaCalendarMinus /> Add Absent
        </h1>
        <hr />
        <h1 className="add-absent-subtitle">
          <FaUserEdit /> Manual Attendance Record
        </h1>
        <hr />
      </div>
      <div className="add-absent-container">
        <Row className="mb-3">
          <Form.Group as={Col} xs={12} md={3} controlId="formGridUsername">
            <Form.Label>
              Username<span className="required">*</span> :
            </Form.Label>
            <CustomSelect
              options={usernameOptions}
              value={username}
              onChange={setUsername}
              placeholder="--Select--"
            />
          </Form.Group>

          <Form.Group as={Col} xs={12} md={3} controlId="formGridDate">
            <Form.Label>
              Date <span className="required">*</span> :
            </Form.Label>
            <Form.Control
              type="date"
              id="date"
              name="date"
              className="form-control"
              required
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </Form.Group>
        </Row>
        <Button className='btn btn-primary'><IoMdAdd /> Add Absent</Button>
      </div>
    </>
  );
}
